import styled from 'styled-components';

interface ProfileInitialProps {
	size: number;
	fontSize: number;
}
export const ProfileInitial = styled.div<ProfileInitialProps>`
	width: ${({ size }) => size}px;
	height: ${({ size = 32 }) => size}px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	font-weight: 600;
	font-size: ${({ fontSize }) => fontSize}px;
	color: white;
	text-shadow: 0 2px 6px rgba(0, 0, 0, 0.6), 0 -2px 6px rgba(0, 0, 0, 0.6);
`;
